import { render, staticRenderFns } from "./TodaysInventoryPiecesProcessedByHour.vue?vue&type=template&id=9068b4da&scoped=true&"
import script from "./TodaysInventoryPiecesProcessedByHour.vue?vue&type=script&lang=js&"
export * from "./TodaysInventoryPiecesProcessedByHour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9068b4da",
  null
  
)

export default component.exports